import { store } from '#app/store'
import { closeConfiguration, type LocalConfigurationId } from '#app/store/slices/configurationSlice'
import { storageEventBus } from '#store/middleware/localStorage'
import type { ComparisonDataEntry } from '../Comparison/useLinearizeComparisonData'
import { redirectMode } from './RedirectMode'

export const exitApplication = (configurationId: LocalConfigurationId | undefined, backUrl: string) => {
  const redirect = () => {
    if (redirectMode === 'same-tab') {
      window.location.href = backUrl
    } else if (redirectMode === 'new-tab') {
      window.open(backUrl, '_blank', 'noopener noreferrer')
    }
    storageEventBus.off('save', redirect)
  }

  // wait until the store has saved before exiting the application
  storageEventBus.on('save', redirect)
  store.dispatch(closeConfiguration(configurationId))
}

export const estimateChangeTableSize = (entry: ComparisonDataEntry) => {
  switch (entry.type) {
    case 'group': {
      const anyGroup = entry.base ?? entry.comparison
      if (!anyGroup?.parentGroup) {
        return 50
      }
      return 41
    }
    case 'family':
      return 34
  }
}
